var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89264 6.85877C2.58027 6.47956 1.97066 6.72486 2.0011 7.21753L3.79605 20.0849C3.86255 21.1614 4.74497 22 5.81115 22H18.1889C19.255 22 20.1374 21.1614 20.204 20.0849L21.9989 7.21753C22.0293 6.72486 21.4197 6.47956 21.1074 6.85877L18.0768 10.5378C17.6004 11.1161 16.6902 10.9919 16.3823 10.3066L12.919 2.59867C12.5604 1.80044 11.4396 1.80044 11.081 2.59867L7.61772 10.3066C7.30977 10.9919 6.39959 11.1161 5.92316 10.5378L2.89264 6.85877ZM8.95243 16.1277H15.0476C15.4657 16.1277 15.8047 16.4706 15.8047 16.8936C15.8047 17.3167 15.4657 17.6596 15.0476 17.6596H8.95243C8.53427 17.6596 8.19529 17.3167 8.19529 16.8936C8.19529 16.4706 8.53427 16.1277 8.95243 16.1277Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownAlt);
export default __webpack_public_path__ + "static/media/crown-alt.23ea89dbdb3ec5d966d578ea94ec36d5.svg";
export { ForwardRef as ReactComponent };